import React from 'react'
import Employee from './components/Employee'
import Manager from './components/Manager'
import Executive from './components/Executive'
import Modal from './components/Modal'
import scaleImg from "../../../assets/rating.png"
const Survey = () => {

  const [questions, setQuestions] = React.useState(
    JSON.parse(sessionStorage.getItem('survey-questions') || '[]')
  );
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [showSurveyWelcome, setShowSurveyWelcome] = React.useState(false);

  const activeAssessment = JSON.parse(
    window.sessionStorage.getItem('active-assessment') || '{}'
  )
  const surveyType = sessionStorage.getItem('assessment-type')

  React.useEffect(() => {
      setShowSurveyWelcome(true);
  }, []);

  const handleCloseSurveyWelcome = (visible: boolean) => {
    setShowSurveyWelcome(visible);
    try {
      localStorage.setItem('surveyWelcomeShown', 'true');
    } catch (e) {
      // ignore
    }
  };

  return (
    <div className=' min-h-screen p-2 overflow-y-auto mb-3'>
      {showSurveyWelcome && (
        <Modal closeModal={handleCloseSurveyWelcome} title={
          surveyType === 'survey'  ?
          activeAssessment?.assessment?.preferred_exam_title :
            activeAssessment?.survey_title
          }>
          <div className="space-y-4 text-md text-gray-700">
            <p className='text-xl font-semibold'>
              This 360 Feedback is designed to help {
                surveyType === 'survey' ? 'you' : activeAssessment?.user_name
              } understand  {
                surveyType === 'survey' ? 'your' : 'his/her'
              } strengths and prioritize any areas to improve 
            </p>
            <div className="space-y-2">
              <p className='text-lg'>
                 The assessment typically takes 10 minutes to fill. We recommend spending at 
                 least 5 minutes on the key strengths and areas to improve 
                 questions at the end of the questionnaire. Feedback
                  should be constructive using examples wherever possible 
              </p>
              <p className='text-lg mt-3'>
                 When asked to provide a score, please use the following scale 
              </p>
              <img src={scaleImg} alt="scale image" />
              <p className='text-lg mt-3'>
                <strong>Note:</strong> You can save your answers by clicking <strong>“Save Draft”</strong> so you can return later if needed
              </p>
              
            </div>
          </div>
        </Modal>
      )}
       <header className='bg-primary pt-6 pb-3 md:py-8 px-3 rounded-lg -mt-1 mb-3 md:flex justify-between items-center'>
          <div className="">
            <h5 className='text-2xl font-bold text-white'>{activeAssessment?.survey_title}</h5>
          <p className='text-white mt-2'>Complete your survey by answering the all questions below.</p>
          </div>
          <div className='text-white font-bold text-lg md:text-xl flex justify-end pt-4 md:pt-0'>
            {activeAssessment?.user_name}
          </div>
       </header>
        {/* <h1 className='text-lg font-semibold mb-5'>1. KEY ACHIEVEMENT EMPLOYEE</h1> */}
        <section className='grid grid-cols-1 gap-5 md:grid-cols-1'>
            <Employee questions={questions} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} />
            {/* <Manager />
            <Executive /> */}
        </section>
    </div>
  )
}

export default Survey